<template>
  <v-card class="mx-auto">
    <v-navigation-drawer
      mobile-breakpoint="600"
      v-model="drawer"
      app
      width="310"
    >
      <v-list nav dense>
        <v-list-item>
          <v-list-item-content>
            <v-list-item>
              <v-img
                lazy-src="@/assets/ekomplet_480.png"
                max-height="150"
                max-width="250"
                src="@/assets/ekomplet_480.png"
              ></v-img>
            </v-list-item>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list-item link to="/introduction">
          <v-list-item-title>Introduction</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/authentication">
          <v-list-item-title>Authentication</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/versioning">
          <v-list-item-title>Versioning</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/filtering">
          <v-list-item-title>Filtering</v-list-item-title>
        </v-list-item>
        <v-list-item link to="/response">
          <v-list-item-title>Response</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="isLoggedIn" link to="/customers">
          <v-list-item-title>Admin Panel</v-list-item-title>
        </v-list-item>

        <v-list-group :value="false" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>V4.0</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="([title, url], i) in sortedArrayV4"
            :key="i"
            link
            :to="url"
          >
            <v-list-item-title v-text="title"></v-list-item-title>
          </v-list-item>
        </v-list-group>


        <v-list-group :value="false" no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>V3.0</v-list-item-title>
            </v-list-item-content>
          </template>
          <v-list-item
            v-for="([title, url], i) in sortedArrayV3"
            :key="i"
            link
            :to="url"
          >
            <v-list-item-title v-text="title"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
      <template v-slot:append>
        <div class="deprecation-note pa-2">
          <div class="deprecation-note-row">
            <v-icon small color="#8a5a00">mdi-alert-outline</v-icon>
            <span class="deprecation-note-text">{{ $t("docsDeprecation.badge") }}</span>
          </div>
          <v-btn
            x-small
            outlined
            color="warning"
            class="deprecation-btn mt-1"
            @click="showDeprecationDialog = true"
          >
            {{ $t("docsDeprecation.readMore") }}
          </v-btn>
        </div>
        <div class="pa-2">API VERSION: 4.0</div>
      </template>
    </v-navigation-drawer>

    <v-dialog v-model="showDeprecationDialog" max-width="460">
      <v-card>
        <v-card-title class="text-subtitle-1">
          {{ $t("docsDeprecation.dialogTitle") }}
        </v-card-title>
        <v-card-text>
          {{ $t("docsDeprecation.line1") }}
          <br />
          {{ $t("docsDeprecation.line2") }}

          <div class="mt-2">
            <div class="deprecation-link-label">{{ $t("docsDeprecation.urlLabel") }}</div>
            <a
              :href="apiDocsUrl"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ apiDocsUrl }}
            </a>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            small
            color="primary"
            :href="apiDocsUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $t("docsDeprecation.openApiDocs") }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="showDeprecationDialog = false">
            {{ $t("docsDeprecation.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<style scoped>
.deprecation-note {
  margin: 8px 4px;
  border-left: 4px solid #f0a500;
  border-radius: 4px;
  background-color: #fff6db;
}

.deprecation-note-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.deprecation-note-text {
  font-size: 0.8rem;
  font-weight: 600;
  color: #5d3b00;
  line-height: 1.2;
}

.deprecation-btn {
  text-transform: none;
  font-weight: 600;
}

.deprecation-link-label {
  font-size: 0.8rem;
  font-weight: 600;
}
</style>
<script>
export default {
  created() {
    this.$root.$on("toggle-side-bar", () => {
      this.drawer = !this.drawer;
    });
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
    sortedArrayV4: function () {
      return this.coreResourcesV4.slice(0).sort();
    },
    sortedArrayV3: function () {
      return this.coreResourcesV3.slice(0).sort();
    },
    apiDocsUrl: function () {
      const lang = this.$i18n.locale === "en" ? "en" : "da";
      return `https://externalaccessapi.e-komplet.dk/scalar/v4-${lang}`;
    },
  },
  data() {
    return {
      drawer: true,
      showDeprecationDialog: false,
      coreResourcesV4: [
        ["AssociatedPeople", "/associatedpeoplev4"],
        ["Budgets", "/budgetsv4"],
        ["CalendarEvents", "/calendareventsV4"],
        ["Creditors", "/creditorsV4"],
        ["Debtors", "/debtorsV4"],
        ["DeletedEntities", "/deletedentitiesv4"],
        ["FinancialAccounts", "/financialaccountsv4"],
        ["FinancialPosts", "/financialpostsv4"],
        ["FitterHours", "/fitterhoursv4"],
        ["Fitters", "/fittersv4"],
        ["Invoices", "/invoicesv4"],
        ["InvoiceLines", "/invoicelinesv4"],
        ["Offers", "/offersv4"],
        ["ProjectBudgets", "/projectbudgetsv4"],
        ["Projects", "/projectsV4"],
        ["QA", "/qav4"],
        ["Roles", "/rolesv4"],
        ["SiteMetadata", "/sitemetadatav4"],
        ["Worksheets", "/worksheetsv4"]
      ],
      coreResourcesV3: [
        ["Budgets", "/budgets"],
        ["CalendarEvents", "/calendarevents"],
        ["CarrierDimensions", "/carrierdimensions"],
        ["ClosedProjects", "/closedprojects"],
        ["Creditors", "/creditors"],
        ["Debtors", "/debtors"],
        ["DepartmentDimensions", "/departmentdimensions"],
        ["FinancialAccounts", "/financialaccounts"],
        ["FinancialPostParentAccounts", "/financialpostparentaccounts"],
        ["FinancialPosts", "/financialpost"],
        ["FitterCategories", "/fittercategories"],
        ["FitterHours", "/fitterhours"],
        ["Fitters", "/fitters"],
        ["InvoiceLines", "/invoicelines"],
        ["Invoices", "/invoices"],
        ["Offers", "/offers"],
        ["PriceGroups", "/pricegroups"],
        ["ProfitGroups", "/profitgroups"],
        ["ProjectGroups", "/projectgroups"],
        ["Projects", "/projects"],
        ["PurchaseInvoiceLines", "/purchaseinvoicelines"],
        ["PurchaseInvoices", "/purchaseinvoices"],
        ["PurposeDimensions", "/purposedimensions"],
        ["SalaryPeriods", "/salaryperiods"],
        ["Users", "/users"],
        ["Worksheets", "/worksheets"]
      ],
    };
  },
};
</script>
